"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;
var _react = _interopRequireDefault(require("react"));
var RadixAvatar = _interopRequireWildcard(require("@radix-ui/react-avatar"));
var _Status = require("../Status");
var _Icons = require("../Icons");
var _AvatarIconSize = require("./AvatarIconSize.constants");
var _classnames = _interopRequireDefault(require("classnames"));
var _AvatarModule = _interopRequireDefault(require("./Avatar.module.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Avatar = _ref => {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'regular' : _ref$size,
    imageURL = _ref.imageURL,
    statusType = _ref.statusType,
    badgeContent = _ref.badgeContent,
    isActive = _ref.isActive,
    isRaised = _ref.isRaised,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
    _ref$isGroup = _ref.isGroup,
    isGroup = _ref$isGroup === void 0 ? false : _ref$isGroup;
  var renderDefaultIcon = () => {
    if (isGroup) {
      return /*#__PURE__*/_react.default.createElement(_Icons.IconUsers1, {
        size: _AvatarIconSize.AVATAR_ICON_SIZE[size]
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_Icons.IconCurrencyEthereum, {
        size: _AvatarIconSize.AVATAR_ICON_SIZE[size]
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_AvatarModule.default.Avatar, {
      [_AvatarModule.default.isActive]: isActive,
      [_AvatarModule.default.isRaised]: isRaised
    }, className),
    "data-size": size,
    tabIndex: tabIndex
  }, /*#__PURE__*/_react.default.createElement(RadixAvatar.Root, {
    className: _AvatarModule.default.Root
  }, /*#__PURE__*/_react.default.createElement(RadixAvatar.Image, {
    className: _AvatarModule.default.Image,
    src: imageURL,
    alt: "avatar"
  }), /*#__PURE__*/_react.default.createElement(RadixAvatar.Fallback, {
    className: _AvatarModule.default.Fallback,
    delayMs: imageURL ? 500 : 0
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_AvatarModule.default.DefaultIcon, {
      [_AvatarModule.default.isGroup]: isGroup
    })
  }, renderDefaultIcon()))), size != 'extra small' && statusType && /*#__PURE__*/_react.default.createElement(_Status.Status, {
    className: _AvatarModule.default.Status,
    type: statusType
  }), size != 'extra small' && badgeContent && /*#__PURE__*/_react.default.createElement(AvatarBadge, {
    badgeContent: badgeContent
  }));
};
exports.Avatar = Avatar;
var AvatarBadge = _ref2 => {
  var badgeContent = _ref2.badgeContent;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _AvatarModule.default.Badge
  }, " ", badgeContent);
};
//# sourceMappingURL=Avatar.js.map